export type TableCol =
  | 'name'
  | 'text'
  | 'num'
  | 'date'
  | 'currency'
  | 'status'
  | 'compact'
  | 'actions'

export function colClass(col?: TableCol): string {
  return col ? `col-${col}` : ''
}
